import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import pen from "../../../assets/images/pen.svg";
import {
  useAnalyzeWritingStyleMutation,
  useCreateWritingStyleMutation,
  useDeleteSelectedWritingStyleMutation,
  useDeleteWritingStyleMutation,
  useGetAllWritingStylesQuery,
  useGetSingleWritingStyleMutation,
  useLinkSingleWritingStyleToWebsiteMutation,
  useUpdateSingleWritingStyleMutation,
  useWritingStyleMutation,
} from "../../../redux/slices/profileApiSlice";
import { WritingStyleInitialValues, WritingStyleSchema } from "../helper";
import DefaultGV from "./DefaultGV";

const WritingStyle = () => {
  const { t } = useTranslation();
  const [counter, setCounter] = useState(0);

  const currentProject = useSelector((state) => state?.project);
  const isInitialized = currentProject?.isInitialized;
  const website_url = currentProject?.project?.id
    ? currentProject?.project?.id
    : null;

  const [writing, { isLoading }] = useWritingStyleMutation();
  const [singleWriting, { isLoading: loadingSingleWriting }] =
    useGetSingleWritingStyleMutation();
  const [updateWriting, { isLoading: loadingUpdate }] =
    useUpdateSingleWritingStyleMutation();
  const [linkWritingStyleToWebsite, { isLoading: linkUpdate }] =
    useLinkSingleWritingStyleToWebsiteMutation();
  const {
    data: writingStyles,
    isLoading: loadingWritingStyles,
    refetch,
  } = useGetAllWritingStylesQuery(
    { website_url },
    {
      skip: isInitialized === false && currentProject?.project != null,
    }
  );
  const [deleteWritingStyle, { isLoading: loadingDelete }] =
    useDeleteWritingStyleMutation();
  const [
    deleteSelectedWritingStyle,
    { isLoading: loadingDeleteSelectedWritingStyle },
  ] = useDeleteSelectedWritingStyleMutation();

  const [analyzeWritingStyle, { isLoading: loadingAnalyze }] =
    useAnalyzeWritingStyleMutation();
  const [createWritingStyle, { isLoading: loadingCreate }] =
    useCreateWritingStyleMutation();

  const variables = writingStyles?.data ? writingStyles?.data : [];

  useEffect(() => {
    if (isInitialized) {
      refetch();
    }
  }, [counter]);

  return (
    <DefaultGV
      counter={counter}
      setCounter={setCounter}
      variable={writing}
      loadingVariable={isLoading}
      singleVariable={singleWriting}
      updateVariable={updateWriting}
      loadingUpdate={loadingUpdate}
      linkVariableToWebsite={linkWritingStyleToWebsite}
      variables={variables}
      refetch={refetch}
      deleteVariable={deleteWritingStyle}
      loadingDelete={loadingDelete}
      analyzeVariable={analyzeWritingStyle}
      loadingAnalyze={loadingAnalyze}
      createVariable={createWritingStyle}
      loadingCreate={loadingCreate}
      variableId={"style"}
      variableTitle={"Style d'écriture"}
      variableNameAndPronoun={t("The-writing-style", "Le style d'écriture")}
      variableImage={pen}
      variableFull={"writing_style_full"}
      initialValues={WritingStyleInitialValues}
      validationSchema={WritingStyleSchema}
      manualText={
        "Créez manuellement votre style d'écriture. Vous pouvez suivre les différents points pour vous aiguiller puis repasser sur le contenu, ou tout simplement rédiger votre style de 0."
      }
      manualBtnText={t("Create-writing-style", "Créer le style d'écriture")}
      autoText={
        "Entrez simplement l'URL de votre site web ou d'un site web dont vous souhaiteriez que l'IA s'inspire pour son style d'écriture. Cliquez sur le bouton \"Analyser le style\" et l'IA se charge du reste !"
      }
      autoBtnText={t("Analyse-writing-style", "Analyser le style d'écriture")}
      bulkDeleteVariables={deleteSelectedWritingStyle}
    />
  );
};

export default WritingStyle;
